import { RotateCcw, RotateCw } from 'lucide-react'

import { cn } from '@/lib/utils'

type Props = {
  direction: 'backward' | 'forward'
  seconds: number
  size: number
  className?: string
}

/** 矢印アイコンの中央にスキップ秒数を重ねて表示する */
export const SkipIcon = ({ direction, seconds, size, className }: Props) => {
  const Icon = direction === 'backward' ? RotateCcw : RotateCw

  return (
    <span
      className={cn('relative inline-flex items-center justify-center', className)}
      style={{ width: size, height: size }}
    >
      <Icon size={size} />
      {/* 矢印の先端が上にはみ出すぶん、視覚的な中心へ少し下げる */}
      <span
        className="absolute font-semibold leading-none tabular-nums"
        style={{ fontSize: Math.round(size * 0.3), top: '52%', transform: 'translateY(-50%)' }}
      >
        {seconds}
      </span>
    </span>
  )
}
